import React from "react";
import QuotationView from "../../../Admin/Quotation/QuotationView/QuotationView";
import { useState } from "react";
import { handleGetAddons_list, handleGetOrder_list } from "./orderListModel";
import { decrypt } from "../../../../MIS/encryption";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import BillPreview from "./BillPreview";

const OrderView = () => {
  const { id } = useParams();
  const [quote, setQuote] = useState({});
  const [quotations, setQuotations] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [addons, setAddons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addonLoading, setAddonLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({
    limit: 1,
    page: page,
    id: decrypt(id),
  });
  useEffect(() => {
    handleGetAddons_list({ setAddonLoading, setAddons });
    handleGetOrder_list({ filter, setLoading, setTotalPage, setQuotations });
  }, [filter]);

  const billData = {
    id: "INV12345",
    date: "2025-07-13",
    customerName: "John Doe",
    customerAddress: "123 Main Street, New Delhi",
    items: [
      { name: "Wireless Mouse", qty: 2, price: 500 },
      { name: "Keyboard", qty: 1, price: 1200 },
    ],
    total: 2200,
  };
  return (
    <>
      {loading || addonLoading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <span
            className="text-primary spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
            style={{ width: "2rem", height: "2rem" }}
          ></span>
        </div>
      ) : quotations.length === 0 ? (
        <div className="text-center text-muted py-4">
          <h5>No records found</h5>
        </div>
      ) : (
        <>
         <BillPreview quote={quotations?.[0]} addons={addons} />         
        </>
      )}
    </>
  );
};

export default OrderView;
